import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { WorkflowComponent } from './workflow.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { WorkflowGuardsModule } from './workflow-guards.module';
import { EcpWorkflowModule } from './ecp-workflow/ecp-workflow.module';
import { SharedModule } from '@shared/shared.module';

// TODO: Add interceptor or remove httpclientmodule
@NgModule({
  declarations: [WorkflowComponent],
  exports: [],
  imports: [RouterModule, CommonModule, WorkflowGuardsModule, EcpWorkflowModule, SharedModule],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class WorkflowModule {}
